import { Injectable } from '@angular/core';
import { AuthService } from '@auth/auth.service';
import { BasketParse, InfoDoc, RegExpDateFR } from '@documalis/_const/const';
import { dateFormat, format, formatDateUserFrToInternal } from '@core/_utils/date.utils';
import { clearStorage, ExecRegExp, getParseDate, getParseToken, getProperty } from '@core/_utils/tools.utils';
import { getTokenBody } from '@auth/auth.helpers';
import { Router } from '@angular/router';

@Injectable()
export class ParseService {
    public userInfos;
    private basketName = '';
    private docInfo: any;
    private variable: any;

    private flag = 'mig';
    private currentUser;
    private initialized: boolean;

    constructor(private _router: Router) {
        this.setInitialized(false);
    }

    public clear() {}

    private initialize() {
        const token = getParseToken();
        if (token) {
            this.currentUser = getTokenBody(token.token).user;
            let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
            this.userInfos = wInternal.internal;
            this.setInitialized(true);
        } else {
            clearStorage();
            this._router.navigate(['expired']);
        }
    }

    public setInitialized(aValue) {
        this.initialized = aValue;
    }

    public setBasketName(aName) {
        this.basketName = aName;
    }

    public setDocInfo(aDocInfo) {
        this.docInfo = aDocInfo;
    }

    public setVariable(aVariable) {
        this.variable = aVariable;
    }

    public verifyParse(aValue) {
        const regex = new RegExp(BasketParse, this.flag);
        return regex.test(aValue);
    }

    public execParse(aValue) {
        let wRes: any;
        if (this.initialized === false) {
            this.initialize();
        }
        if (this.verifyParse(aValue)) {
            wRes = this.parseValue(aValue);
        } else {
            wRes = aValue;
        }
        return wRes;
    }

    private parseValue(aValue) {
        let wResult = aValue;
        let wRes: any;
        const regex = new RegExp(BasketParse, this.flag);
        wRes = regex.exec(aValue);
        if (wRes[1] !== undefined && wRes[2] !== undefined && wRes[3] !== undefined) {
            wRes = this.updateRes(wRes);
            wRes = this.execAction(wRes);
            wResult = wRes;
        }
        return wResult;
    }

    private updateRes(aRes) {
        let wData = '';
        wData = aRes[3];
        aRes[1] = aRes[1].toLowerCase();
        aRes[2] = aRes[2].toLowerCase();
        // gestion de 2 syntaxe : avec ou sans guillemet
        // <<bsk:datetime(dd/mm/yyyy)>>
        // <<bsk:datetime("dd/mm/yyyy")>>
        if (wData.substring(0,2) === '("') {
            aRes[3] = wData.substring(2, wData.length - 2);
        } else {
            aRes[3] = wData.substring(1, wData.length - 1);
        }
        aRes[3] = aRes[3].toLowerCase();
        return aRes;
    }

    private execAction(aData) {
        var fn;
        const type = {
            bsk: this.getParseBsk,
            default: this.getParseDefAction,
        };
        if (type[aData[1]]) {
            fn = type[aData[1]](aData, this);
        } else {
            fn = type['default'](aData);
        }
        return fn;
    }

    private getParseBsk(aData, self) {
        var fn;
        const typeact = {
            variable: self.getParseVar,
            docinfo: self.getParseInfo,
            property: self.getParseProp,
            datetime: self.getParseDateTime,
            default: self.getParseDefBsk,
        };
        if (typeact[aData[2]]) {
            fn = typeact[aData[2]](aData, self);
        } else {
            fn = typeact['default'](aData);
        }
        return fn;
    }

    private getParseDefAction(aData) {
        return aData[0];
    }

    private getParseVar(aData, self) {
        let wResult = aData[0];
        if (self.variable !== undefined) {
            for (const item of self.variable) {
                if (item.Name.toUpperCase() === aData[3].toUpperCase()) {
                    wResult = item.value;
                    break;
                }
            }
        }
        return wResult;
    }

    // Parsing des infos du document
    private getParseInfo(aData, self) {
        let wResult = aData[0];
        var wType = aData[3];
        if (InfoDoc.indexOf(aData[3]) !== -1 && self.docInfo !== undefined) {
            // Historique
            if (wType === 'DocName') {
                wType = 'Name';
            }
            wResult = getProperty(self.docInfo, wType);
        }
        return wResult;
    }

    // Parsing de la date
    private getParseDateTime(aData, self) {
        let wResult = aData[0];
        let wformat;
        if (aData[3]) {
            wformat = getParseDate(aData[3]);
            if (wformat) {
                wResult = dateFormat(null, wformat.useValue);
            } else {
                wResult = self.checkDate(aData);
            }
        }
        return wResult;
    }

    private checkDate(aData) {
        if (!ExecRegExp(RegExpDateFR, '', aData[3])) {
            return aData;
        } else {
            return formatDateUserFrToInternal(aData[3]);
        }
    }

    private getParseDefBsk(aData) {
        return aData[0];
    }

    // Parsing des propriétés de l'utilisateur / bannette
    private getParseProp(aData, self) {
        var fn;
        const type = {
            userlogin: self.getParseUser,
            user: self.getParseUser,
            firstname: self.getParseFirst,
            userfirstname: self.getParseFirst,
            lastname: self.getParseLast,
            userlastname: self.getParseLast,
            useremail: self.getEmail,
            currentbasket: self.getCurrentBasket,
            'firstname lastname': self.getParseFirstL,
            'lastname firstname': self.getParseLastF,
            default: self.getParseDefProp,
        };

        if (type[aData[3]]) {
            fn = type[aData[3]](self);
        } else {
            fn = type['default'](aData);
        }
        return fn;
    }

    private getParseUser(self) {
        return self.userInfos.Login;
    }

    private getParseFirst(self) {
        return self.userInfos.FirstName;
    }

    private getParseLast(self) {
        return self.userInfos.LastName;
    }

    private getParseFirstL(self) {
        if (self.userInfos.FirstName && self.userInfos.LastName) {
            return self.userInfos.FirstName + ' ' + self.userInfos.LastName;
        }
    }

    private getParseLastF(self) {
        if (self.userInfos.FirstName && self.userInfos.LastName) {
            return self.userInfos.LastName + ' ' + self.userInfos.FirstName;
        }
    }

    private getEmail(self) {
        return self.userInfos.Email;
    }

    private getCurrentBasket(self) {
        return self.basketName;
    }

    private getParseDefProp(aData) {
        return aData[0];
    }
}
